const actions = {}
export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js